"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNAUTHORIZED = exports.TEMPORARY_REDIRECT = exports.REQUEST_TIMEOUT = exports.OK = exports.NOT_IMPLEMENTED = exports.NOT_FOUND = exports.MOVED_TEMPORARILY = exports.MOVED_PERMANENTLY = exports.INTERNAL_SERVER_ERROR = exports.GATEWAY_TIMEOUT = exports.FORBIDDEN = exports.BAD_REQUEST = void 0;
// 20x
var OK = exports.OK = 200;

// 30x
var MOVED_PERMANENTLY = exports.MOVED_PERMANENTLY = 301;
var MOVED_TEMPORARILY = exports.MOVED_TEMPORARILY = 302;
var TEMPORARY_REDIRECT = exports.TEMPORARY_REDIRECT = 307;

// 40x
var BAD_REQUEST = exports.BAD_REQUEST = 400;
var FORBIDDEN = exports.FORBIDDEN = 403;
var UNAUTHORIZED = exports.UNAUTHORIZED = 401;
var NOT_FOUND = exports.NOT_FOUND = 404;
var REQUEST_TIMEOUT = exports.REQUEST_TIMEOUT = 408;

// 50x
var INTERNAL_SERVER_ERROR = exports.INTERNAL_SERVER_ERROR = 500;
var NOT_IMPLEMENTED = exports.NOT_IMPLEMENTED = 501;
var GATEWAY_TIMEOUT = exports.GATEWAY_TIMEOUT = 504;